import { useLayoutEffect } from 'react';

var index =  useLayoutEffect ;

export default index;
import { useLayoutEffect } from 'react';

var index =  useLayoutEffect ;

export default index;
